export const cards = [{
        "label": "0",
        "route": "0"
    },
    {
        "label": "½",
        "route": "half"
    },
    {
        "label": "1",
        "route": "1"
    },
    {
        "label": "2",
        "route": "2"
    },
    {
        "label": "3",
        "route": "3"
    },
    {
        "label": "5",
        "route": "5"
    },
    {
        "label": "8",
        "route": "8"
    },
    {
        "label": "13",
        "route": "13"
    },
    {
        "label": "20",
        "route": "20"
    },
    {
        "label": "40",
        "route": "40"
    },
    {
        "label": "100",
        "route": "100"
    },
    {
        "label": "?",
        "route": "question"
    },
    {
        "label": "☕",
        "route": "coffee"
    }
];


// WEBPACK FOOTER //
// ./src/cards/config.js